import type { MediaFragment } from "~/lib/api-types";

export const openModal = async (title: string | null, content: string) => {
  const Modal = (await import("../components/modals/Modal.vue")).default;
  const { useModal } = await import("vue-final-modal");

  const modal = useModal({
    component: Modal,
    attrs: { title: title || "", rawContent: content },
  });
  modal.open();
};

export const openIframeModal = async (url: string) => {
  const Modal = (await import("../components/modals/Modal.vue")).default;
  const { useModal } = await import("vue-final-modal");

  const modal = useModal({
    component: Modal,
    attrs: {
      size: "page",
      rawContent: `<iframe src="${url}" frameborder="0" style="width: 100%; height: 100%;" loading="lazy"></iframe>`,
    },
  });
  modal.open();
};

export const openGalleryModal = async (
  images: MediaFragment[] | null,
  initialIndex?: number
) => {
  if (!images?.length) return;

  const GalleryModal = (await import("../components/modals/GalleryModal.vue"))
    .default;
  const { useModal } = await import("vue-final-modal");

  const modal = useModal({
    component: GalleryModal,
    attrs: { images, initialIndex },
  });
  modal.open();
};

export const openJobModal = async (jobTitle, form) => {
  const JobModal = (await import("../components/modals/JobModal.vue")).default;
  const { useModal } = await import("vue-final-modal");

  const modal = useModal({ component: JobModal, attrs: { jobTitle, form } });
  modal.open();
};

export const openTextAndEmbedModal = async (title, content, embedUrl) => {
  const TextAndEmbedModal = (
    await import("../components/modals/TextAndEmbedModal.vue")
  ).default;
  const { useModal } = await import("vue-final-modal");

  const modal = useModal({
    component: TextAndEmbedModal,
    attrs: { title, content, embedUrl },
  });
  modal.open();
};

export const openTextAndImageModal = async (title, content, image) => {
  const TextAndImageModal = (
    await import("../components/modals/TextAndImageModal.vue")
  ).default;
  const { useModal } = await import("vue-final-modal");

  const modal = useModal({
    component: TextAndImageModal,
    attrs: { title, content, image },
  });
  modal.open();
};
